export default {"src":"/_next/static/media/bay-lines.3b5c7866.svg","height":25,"width":115,"blurWidth":0,"blurHeight":0};